import { Box } from "@mui/material"
import AppButton from "components/StyledComponents/AppButton"
import AppTextField from "components/StyledComponents/AppTextField"
import React from "react"
import styles from "../tile.module.scss"

const AddNewTileForm = ({ formik, isEdit, onClose = () => {} }) => {
  return (
    <Box className="d-flex flex-column h-100" mt={3}>
      <Box flexGrow={1}>
        <AppTextField
          id="tileName"
          name="tileName"
          className="mb-4"
          label="Tile Name"
          placeholder="Enter the tile name"
          fullWidth
          isUpperCase={true}
          isRequired={true}
          value={formik.values.tileName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.tileName && Boolean(formik.errors.tileName)}
          helperText={formik.touched.tileName && formik.errors.tileName}
        />
        <AppTextField
          id="link"
          name="link"
          label="Link"
          placeholder="Enter the link"
          fullWidth
          isUpperCase={true}
          isRequired={true}
          value={formik.values.link}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.link && Boolean(formik.errors.link)}
          helperText={formik.touched.link && formik.errors.link}
        />
      </Box>

      <Box className="d-flex gap-3 justify-content-center">
        <AppButton className={styles.saveBtn} onClick={() => onClose()}>
          Cancel
        </AppButton>
        <AppButton className={styles.saveBtn} onClick={formik.handleSubmit}>
          {isEdit ? "Update" : "Save"}
        </AppButton>
      </Box>
    </Box>
  )
}

export default AddNewTileForm
